/**
 * Combines prototype objects into a new one while keeping getters and setters as such
 * Overwritten methods are added as .super property on the current
 * @param {object[]} objects
 * @returns {object}
 */
export function composePrototype(...objects){
  const composition = {}
  objects.reverse().forEach(obj=>{
    Object.entries(obj).forEach(([name,method])=>{
      const descriptor = Object.getOwnPropertyDescriptor(obj,name)
      const exists = composition.hasOwnProperty(name)
      exists&&method&&(composition[name].super = obj[name])
      !exists&&Object.defineProperty(composition,name,descriptor)
    })
  })
  return composition
}


// WEBPACK FOOTER //
// ./src/js/util/object.js